import styled, { css } from 'styled-components';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';

export const TransactionsList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 24px;
`;

export const ListRow = styled.li<{ $isRusLanguage: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 8px;

  ${({ $isRusLanguage }) => {
    if ($isRusLanguage) {
      return css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      `;
    }
  }}
`;

export const TransactionType = styled.div`
  justify-self: flex-end;
  white-space: nowrap;
`;

export const TransactionDate = styled.div`
  justify-self: start;
  font-family: ${FontFamily.Montserrat};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.3px;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${EColors.Gray2};
  font-variant-numeric: lining-nums tabular-nums;
`;

export const TransactionMessage = styled.div`
  grid-column: span 2;
  font-family: ${FontFamily.Montserrat};
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  white-space: wrap;
  color: ${EColors.Gray1Text};
  font-variant-numeric: lining-nums tabular-nums;
`;
